var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable camelcase */
import constructLocalEntity from 'src/utils/vuexModuleConstructor/constructLocalEntity';
import UserCard from './components/UserCard.vue';
import deleteUser from './utils/deleteUser';
import rpc from 'src/api/rpc';
import { inlineEdit, hideWhenCreatingAndEditing, isToggle, editable, isDateTime, required, isButton, hideWhenDisplaying, hideWhenDisplayingInNonTable, limitSavingToOnlyUsingSaveButtonOnTheField, disguised } from 'src/types/columnFlags';
import setCurrentMode from 'src/utils/currentMode/setCurrentMode';
import CreateUser from 'src/platform/pages/CreateUser.vue';
// import phoneDisplayFormatter from 'src/utils/displayFormatters/phoneDisplayFormatter'
import getFullTable from 'src/utils/entityOperations/getFullTable';
import { id } from 'src/utils/entityOperations/columns/basicColumns';
const controlledActions = {
    create: [1],
    fetch: [2],
    update: [3],
    delete: [4],
    downloadList: [2],
    uploadList: [1]
};
const columns = () => {
    return [
        // { name: 'row_menu', type: 'row_menu', menuItems: rowMenuItems, hideWhenCreatingAndEditing },
        { name: 'delete_user', label: '', isButton, icon: 'mdi-trash-can-outline', buttonClickHandler: deleteUser, hideWhenDisplayingInNonTable },
        { name: 'view_user_card', label: '', isButton, icon: 'mdi-eye-outline', buttonClickHandler: (props, ctx, e) => ctx.setDialogComponentPlaceHolder(UserCard, { visibleProp: true, userObjectProp: props.row }), hideWhenDisplayingInNonTable },
        id({ hideWhenDisplaying: true }),
        { name: 'name', disguised, style: 'width:100px;max-width:200px;white-space:nowrap;', inlineEdit, maxLines: 1, align: 'left', limitSavingToOnlyUsingSaveButtonOnTheField, required, uiFilterTypes: ['selectedValuesFilter', 'textFilters'] },
        { name: 'salutation_name', label: 'Salutation', limitSavingToOnlyUsingSaveButtonOnTheField, inlineEdit, align: 'left', uiFilterTypes: ['selectedValuesFilter', 'textFilters'] },
        { name: 'login', disguised, inlineEdit, align: 'left', required, uiFilterTypes: ['selectedValuesFilter', 'textFilters'] },
        { name: 'email', disguised, inlineEdit, limitSavingToOnlyUsingSaveButtonOnTheField, align: 'left', required, uiFilterTypes: ['selectedValuesFilter', 'textFilters'] },
        { name: 'phone', disguised, inlineEdit, limitSavingToOnlyUsingSaveButtonOnTheField, style: 'white-space:nowrap', align: 'left', insteadOfNullShowString: 'none' },
        { name: 'preferred_time_zone', editable, complexlyReferences: { table: getFullTable('calendars.timeZones'), reference_value_field: 'name', type: 'labelField', reference_label_field: 'name' } },
        { name: 'deactivated', editable, isToggle, uiFilterTypes: ['selectedValuesFilter'] },
        { name: 'created_at', isDateTime, hideWhenCreatingAndEditing, uiFilterTypes: ['dateFilters'] },
        { name: 'updated_at', isDateTime, hideWhenCreatingAndEditing, uiFilterTypes: ['dateFilters'] },
        { name: 'employee_roles_in_context_org_and_as_date', hideWhenDisplayingInNonTable, hideWhenDisplaying },
        { name: 'oauth_objects', hideWhenDisplaying },
    ];
};
const genericTableDefaultProps = () => ({
    initiationOfRecordCreationHandlerProp: (newRecord, ctx) => {
        setCurrentMode({ component: CreateUser });
    }
});
const additionalActions = {
    updatePassword: ({ dispatch }, params) => __awaiter(void 0, void 0, void 0, function* () {
        const payload = {
            api_version: 1,
            action: 'call',
            entity: 'users.users_update',
            action_arguments: [
                { argument_number: 1, value: params, type: 'text' },
                { argument_number: 2, value: 'null', type: 'text' }
            ]
        };
        const response = yield rpc('generic_controllers.rpc', payload);
        return response;
    }),
    usersCreate: ({ dispatch }, params) => __awaiter(void 0, void 0, void 0, function* () {
        const payload = {
            api_version: 1,
            action: 'call',
            entity: 'users.users_create',
            action_arguments: [
                { argument_number: 1, value: params, type: 'text' }
            ]
        };
        const response = yield rpc('generic_controllers.rpc', payload);
        return response;
    })
};
const localEntity = constructLocalEntity({
    columns,
    genericTableDefaultProps,
    remoteEntityName: 'users.users',
    apiVersion: 1,
    controlledActions,
    additionalActions,
    pageTitle: 'Users'
});
export default localEntity;
